var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('router-view'),_c('BaseTabBar',{attrs:{"selected":_vm.selected,"tabBars":_vm.tabBars},on:{"onChange":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }